import React from "react";
import { formatDate } from "../../../utils/commonFunctions";
import { CircularAvatar } from "../../commons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  BlueFlagIcon,
  CalanderGrayIcon,
  ClockIcon,
} from "../../../assets/images";
import "./style.scss";
type AppProps = {
  header: any;
  singleJobData: any;
};

const JobChecklistSummary = ({ header, singleJobData }: AppProps) => {
  return (
    <div className="job_checklist_summary_card">
      <div className="job_title"> Job Summary</div>
      <div
        className="mt-2"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {header.map((el: string) => {
          if (el === "jobIdType") {
            return (
              <div style={{ maxWidth: "220px" }}>
                <div className="job_label">Job Type & ID</div>

                <div style={{ wordBreak: "break-word" }}>
                  <span>
                    <img src={BlueFlagIcon} alt="flag" />
                  </span>
                  {singleJobData && Object.keys(singleJobData)?.length ? (
                    <>
                      {" "}
                      {`${
                        singleJobData?.job_id +
                        `_` +
                        singleJobData?.job_type +
                        `_` +
                        singleJobData?.period_ended
                      }`.length < 20 ? (
                        <span className="text_color">{`${
                          singleJobData?.job_id +
                          `_` +
                          singleJobData?.job_type +
                          `_` +
                          singleJobData?.period_ended
                        }`}</span>
                      ) : (
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-open-item">{`${
                              singleJobData?.job_id +
                              `_` +
                              singleJobData?.job_type +
                              `_` +
                              singleJobData?.period_ended
                            }`}</Tooltip>
                          }
                        >
                          <span
                            className="text_color"
                            style={{ width: "100%" }}
                          >
                            {`${
                              singleJobData?.job_id +
                              `_` +
                              singleJobData?.job_type +
                              `_` +
                              singleJobData?.period_ended
                            }`?.slice(0, 20) + "..."}
                          </span>
                        </OverlayTrigger>
                      )}
                    </>
                  ) : (
                    <>
                      {`${
                        singleJobData?.future_job?.job_type +
                        `_` +
                        formatDate(singleJobData?.future_job?.period_ended)
                      }`.length < 35 ? (
                        <span className="text_color">{`${
                          singleJobData?.future_job?.job_type +
                          `_` +
                          formatDate(singleJobData?.future_job?.period_ended)
                        }`}</span>
                      ) : (
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-open-item">{`${
                              singleJobData?.future_job?.job_type +
                              `_` +
                              formatDate(
                                singleJobData?.future_job?.period_ended
                              )
                            }`}</Tooltip>
                          }
                        >
                          <span
                            className="text_color"
                            style={{ width: "100%" }}
                          >
                            {`${
                              singleJobData?.future_job?.job_type +
                              `_` +
                              formatDate(
                                singleJobData?.future_job?.period_ended
                              )
                            }`?.slice(0, 35) + "..."}
                          </span>
                        </OverlayTrigger>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          } else if (el === "description") {
            return (
              <div style={{ maxWidth: "150px", wordBreak: "break-word" }}>
                <span className="job_label">Details</span>
                {singleJobData && Object.keys(singleJobData)?.length ? (
                  <>
                    {singleJobData?.job_description?.length < 35 ? (
                      <div className="text_color">
                        {singleJobData?.job_description}
                      </div>
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 250 }}
                        overlay={
                          <Tooltip id="button-view-open-item">
                            {singleJobData?.job_description}
                          </Tooltip>
                        }
                      >
                        <div className="text_color" style={{ width: "100%" }}>
                          {singleJobData?.job_description?.slice(0, 35) + "..."}
                        </div>
                      </OverlayTrigger>
                    )}
                  </>
                ) : (
                  <>
                    {singleJobData?.future_job?.job_description?.length < 35 ? (
                      <div className="text_color">
                        {singleJobData?.future_job?.job_description}
                      </div>
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 250 }}
                        overlay={
                          <Tooltip id="button-view-open-item">
                            {singleJobData?.future_job?.job_description}
                          </Tooltip>
                        }
                      >
                        <div className="text_color" style={{ width: "100%" }}>
                          {singleJobData?.future_job?.job_description?.slice(
                            0,
                            35
                          ) + "..."}
                        </div>
                      </OverlayTrigger>
                    )}
                  </>
                )}
              </div>
            );
          } else if (el === "startDate") {
            return (
              <div>
                <span className="job_label">Start Date</span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="text_color"
                >
                  {singleJobData?.target_start_date ||
                  singleJobData?.future_job?.target_start_date ? (
                    <img src={CalanderGrayIcon} alt="cal" className="mr-1" />
                  ) : (
                    ""
                  )}
                  {singleJobData && Object.keys(singleJobData)?.length ? (
                    <div>
                      {singleJobData?.target_start_date
                        ? formatDate(singleJobData?.target_start_date)
                        : "--/--"}
                    </div>
                  ) : (
                    <div className="text_color">
                      {singleJobData?.future_job?.target_start_date
                        ? formatDate(
                            singleJobData?.future_job?.target_start_date
                          )
                        : "--/--"}
                    </div>
                  )}
                </div>
              </div>
            );
          } else if (el === "targetEndDate") {
            return (
              <div>
                <span className="job_label">Target End Date</span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {singleJobData?.target_end_date ||
                  singleJobData?.future_job?.target_end_date ? (
                    <img src={CalanderGrayIcon} alt="cal" className="mr-1" />
                  ) : (
                    ""
                  )}
                  {singleJobData && Object.keys(singleJobData)?.length ? (
                    <div className="text_color">
                      {singleJobData?.target_end_date
                        ? formatDate(singleJobData?.target_end_date)
                        : "--/--"}
                    </div>
                  ) : (
                    <div className="text_color">
                      {singleJobData?.future_job?.target_end_date
                        ? formatDate(singleJobData?.future_job?.target_end_date)
                        : "--/--"}
                    </div>
                  )}
                </div>
              </div>
            );
          } else if (el === "estimatedHour") {
            return (
              <div>
                <span className="job_label">Total Estimated Hour</span>
                <div
                  className="text_color"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img src={ClockIcon} alt="cal" className="mr-1" />
                  <div>{singleJobData?.total_scheduled_hours} hours</div>
                </div>
              </div>
            );
          } else if (el === "status") {
            return (
              <div>
                <span className="job_label">Status</span>
                <div  className={`status-chip ${
                          singleJobData?.job_status === "Open"
                            ? "success"
                            : "warning"
                        }`} style={{ display: "flex", alignItems: "center" }}>
                  <div>{singleJobData?.job_status}</div>
                </div>
              </div>
            );
          } else if (el === "CurrentlyResposible") {
            return (
              <div>
                <span className="job_label">Currently Responsible</span>
                <div
                
                  className="text_color"
                  style={{ display: "flex", alignItems: "center", gap: "2px" }}
                >
                  <CircularAvatar
                    name={`${singleJobData?.currently_responsible?.first_name} ${singleJobData?.currently_responsible?.last_name}`}
                    image={
                      singleJobData?.currently_responsible?.profile_pic &&
                      singleJobData?.currently_responsible?.profile_pic
                        ?.file_url
                    }
                  />
                  {`${singleJobData?.currently_responsible?.first_name} ${singleJobData?.currently_responsible?.last_name} `}
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default JobChecklistSummary;
